const updates = [
  { date: '07-30', title: '《封神第二部》高清完整版全网首发上线', tag: '新片速递', highlight: true },
  { date: '07-29', title: '奇优影院片源库新增50部经典港片修复版', tag: '片源更新', highlight: false },
  { date: '07-28', title: 'cc影院日漫专区《进击的巨人》全集上线', tag: '动漫上线', highlight: true },
  { date: '07-27', title: '优优色影院综艺频道《奔跑吧》最新季更新', tag: '综艺更新', highlight: false },
  { date: '07-26', title: '96影院纪录片频道《地球脉动3》4K版上线', tag: '纪录片', highlight: false },
  { date: '07-25', title: '98影院韩剧专区《黑暗荣耀》完整版放送', tag: '韩剧上线', highlight: true },
  { date: '07-24', title: '服务器全面升级，4K超清流畅播放无压力', tag: '系统公告', highlight: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">更新快讯</h2>
          <p className="text-sm text-foreground-500">每日影视动态速递，最新片源一览无余</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="relative flex items-start gap-4 pb-6 last:pb-0"
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 ${
                  item.highlight ? 'bg-primary-500' : 'bg-secondary-400'
                }`}></div>
                {i < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-600 font-mono whitespace-nowrap">{item.date}</span>
                  <span className={`text-xs px-2 py-0.5 rounded whitespace-nowrap ${
                    item.highlight
                      ? 'bg-primary-500/20 text-primary-400'
                      : 'bg-secondary-100/30 text-secondary-400'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <a
                  href="#updates"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors leading-relaxed cursor-pointer"
                >
                  {item.title}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}